export type { FC } from "react";

export const DIRECTIONS = {
  UP: "above",
  DOWN: "below",
  HIDDEN: "hidden",
} as const;

export type DIRECTIONS = (typeof DIRECTIONS)[keyof typeof DIRECTIONS];

export interface Props {
  toggle?: () => void;
  className?: string;
  children: JSX.Element;
  right?: number;
}
